/**
 * @param {Boolean} onlyFirstLetter
 */

export default function (value, onlyFirstLetter) {
  if (!value) return ''
  value = value.toString()
  if (onlyFirstLetter) {
    return value.replace(/(^|\s)\S/g, l => l.toUpperCase())
  } else {
    return value.charAt(0).toUpperCase() + value.substring(1)
  }
}